<template>
  <div>
    <p>Documentation</p>
  </div>
</template>
<script>
import Vue from "vue";
import Component from "vue-class-component";
import router from "@/router/router";
import { mapState, mapGetters } from "vuex";

import {

  Icon as NbIcon
} from "@navblue/navblue-ui";

@Component({
  components: { NbIcon },
  computed: {
    ...mapGetters({
      
    })
  }
})
export default class Documentation extends Vue {

  data() {
    return {

    };
  }
}
</script>
<style lang="scss">

</style>
